var map = {
	"./arrow-bottom.svg": "0725",
	"./events-icon.svg": "d91b",
	"./leaf-icon.svg": "465c",
	"./link-icon.svg": "48c9",
	"./main-leaf.svg": "aad5",
	"./phone-icon.svg": "ef4e",
	"./poweredbyblue.svg": "416e",
	"./report-icon.svg": "eda0",
	"./sidebar-logo.svg": "e40a",
	"./stat.svg": "9ded",
	"./tg-blue.svg": "fac7",
	"./time-blue.svg": "bb40",
	"./user-icon.svg": "7390",
	"./users-icon.svg": "80e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "30ad";